import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import isFinite from 'lodash/isFinite.js';
import { getProp } from './utils.js';

const collator = new Intl.Collator('en', {
  numeric: true,
  sensitivity: 'base'
});
function comparer(a, b) {
  if (a == null) {
    return -1;
  }
  if (b == null) {
    return 1;
  }
  if (isFinite(a) && isFinite(b)) {
    return a - b;
  }
  return collator.compare(a, b);
}
function isTimestamp(value) {
  switch (typeof value) {
    case 'boolean':
      return false;
    case 'string':
      {
        const isOnlyNumbers = /^\d+$/.test(value);
        return isOnlyNumbers && value.length === 13;
      }
    case 'number':
      {
        if (Number.isNaN(value) || !Number.isFinite(value)) {
          return false;
        }
        const isOnlyNumbers = /^\d+$/.test(value);
        return isOnlyNumbers && String(value).length === 13;
      }
    default:
      return false;
  }
}
function compare(a, b, column) {
  let aValue = getProp(a, column.property);
  let bValue = getProp(b, column.property);
  if (column.sortBy) {
    switch (typeof column.sortBy) {
      case 'string':
        aValue = getProp(a, column.sortBy);
        bValue = getProp(b, column.sortBy);
        break;
      case 'function':
        aValue = column.sortBy(a);
        bValue = column.sortBy(b);
        break;
    }
  } else if (column.formatter) {
    if (!isTimestamp(aValue)) {
      aValue = column.formatter(a, column);
    }
    if (!isTimestamp(bValue)) {
      bValue = column.formatter(b, column);
    }
  }
  const order = {
    ascending: 1,
    descending: -1
  }[column.order];
  return comparer(aValue, bValue) * order;
}
function createCompareFunction(column) {
  if (column.sortMethod) {
    return (a, b) => column.sortMethod(a, b, column.order);
  }
  return (a, b) => compare(a, b, column);
}
function sortRow(row, compareFunction) {
  let parents = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  let options = arguments.length > 3 ? arguments[3] : undefined;
  if (options && options.sortChildren && Array.isArray(row[options.childKey])) {
    const childRows = [...row[options.childKey]].sort((a, b) => compareFunction(a, b, [...parents, row])).map(childRow => sortRow(childRow, compareFunction, [...parents, row, childRow], options));
    return _objectSpread2(_objectSpread2({}, row), {}, {
      [options.childKey]: childRows
    });
  }
  return row;
}
function sortRows(_ref) {
  let {
    rows,
    sortConfig,
    options
  } = _ref;
  if (sortConfig.column) {
    if (sortConfig.column.order === 'none') {
      return [...rows];
    }
    const compareFunction = createCompareFunction(sortConfig.column);
    if (options.groupKey) {
      return rows.map(row => sortRow(row, compareFunction, [], options));
    }
    return rows.sort((a, b) => compareFunction(a, b)).map(row => sortRow(row, compareFunction, [], options));
  }
  return rows;
}

export { compare, comparer, isTimestamp, sortRows };
//# sourceMappingURL=sort.js.map
